export default class ComponentLocationDropdown {
    constructor(container) {
        this.options = {
            selectedState: 'data-state',
            selectedVenue: 'data-venue',
            selectorText: '.input-text',
            clickArea: '.click-area',
            desktop: '.venue-selector',
            mobile: '.venue-selector-mobile',
            states: '.states',
            venues: '.venues',
            stateItem: '.states .state',
            venueItem: '.venues .venue',
            body: 'body'
        };
        this.container = container;
        this.clickArea = this.container.querySelector(this.options.clickArea);
        this.items = this.container.querySelectorAll(this.options.item);
        this.selectorText = this.container.querySelector(this.options.selectorText);
        
        this.body = document.querySelector(this.options.body)
        this.venueSelectorDesktop = this.container.querySelector(this.options.desktop);
        this.venueSelectorMobile = this.container.querySelector(this.options.mobile);
        this.states = this.container.querySelectorAll(this.options.states);
        this.venues = this.container.querySelectorAll(this.options.venues);
        
        this.defaultState = this.container.dataset.state;
        this.defaultVenue = this.container.dataset.venue;
        
        if (this.defaultState !== null && this.defaultState !== '') {
            this.filterStateItems(this.defaultState);
        } else {
            this.container.setAttribute(this.options.selectedState, '');
        }

        if (this.defaultVenue !== null && this.defaultVenue !== '') {
            this.setVenue(this.defaultVenue);
        } else {
            this.container.setAttribute(this.options.selectedVenue, '');
        }

        this.setEvents();
    }
    
    setEvents() {
        var self = this;
        this.clickArea.addEventListener('click', this.toggleVenueSelectorDisplay.bind(this));
        this.container.addEventListener('blur', this.hideVenueSelectorDisplay.bind(this));

        let stateItems = this.container.querySelectorAll(this.options.stateItem);
        for(var i = 0; i < stateItems.length; i++) {
            let stateItem = stateItems[i];

            if(this.defaultState === null || this.defaultState === '') {
                if (i === 0) {
                    this.filterStateItems(stateItem.dataset.id);
                    this.container.setAttribute(this.options.selectedState, stateItem.dataset.id);
                }
            }
            stateItem.addEventListener('click', function(event) {
                self.selectState(event, this);
            });
        }

        let venueItems = this.container.querySelectorAll(this.options.venueItem);
        for(var i = 0; i < venueItems.length; i++) {
            let venueItem = venueItems[i];
            venueItem.addEventListener('click', function(event) {
                self.selectVenue(event, this);
            });
        }
    }
    
    selectState(event, element) {
        let id = element.dataset.id;
        this.filterStateItems(id);
        this.container.setAttribute(this.options.selectedState, id);
    }
    
    selectVenue(event, element) {
        let id = element.dataset.id;
        this.setVenue(id);
    }
    
    setVenue(id) {
        this.container.setAttribute(this.options.selectedVenue, id);
        let venueItems = this.container.querySelectorAll(this.options.venueItem);
        venueItems.forEach(item => {
            if(item.dataset.id == id) {
                this.selectorText.innerHTML = item.innerHTML;
            }
        });
        
        
        this.selectorText.classList.add('active');

        this.hideVenueSelectorDisplay();
    }
    
    getVenueSelector() {
        let windowWidth = window.innerWidth
        if (windowWidth >= 768) {
            return this.venueSelectorDesktop;
        }
        else {
            return this.venueSelectorMobile;
        }
    }
    
    toggleVenueSelectorDisplay() {
        let venueSelector = this.getVenueSelector();
        let windowWidth = window.innerWidth
        
        if (venueSelector.classList.contains('show')) {
            venueSelector.classList.remove('show');
            this.body.classList.remove('disable-scrolling')
        } else {
            venueSelector.classList.add('show');
            
            if (windowWidth <= 768) {
                this.body.classList.add('disable-scrolling')
            }
        }
    }
    
    hideVenueSelectorDisplay() {
        let venueSelector = this.getVenueSelector();
        if (venueSelector.classList.contains('show')) {
            venueSelector.classList.remove('show');
            this.body.classList.remove('disable-scrolling')
        }
    }


    filterStateItems(id) {
        let states = this.container.querySelectorAll(this.options.stateItem);
        for(var i = 0; i < states.length; i++) {
            var state = states[i];
            state.classList.remove('active');
            if(state.classList.contains(id)) {
                state.classList.add('active');
            }
        }
        
        let venues = this.container.querySelectorAll(this.options.venueItem);
        for (let i = 0; i < venues.length; i++) {
            this.filterStateItemsRemoveClass(venues[i], 'show');

            // TODO update this to work with multiple states.
            if (typeof venues[i].dataset.region !== 'undefined' && venues[i].dataset.region === id) {
                this.filterStateItemsAddClass(venues[i], 'show');
            }
        }
    }
    
    filterStateItemsAddClass(element, name) {
        let i
        let arr1
        let arr2

        arr1 = element.className.split(" ")
        arr2 = name.split(" ")

        for (i = 0; i < arr2.length; i++) {
            if (arr1.indexOf(arr2[i]) == -1) {
                element.className += " " + arr2[i];
            }
        }
    }
    
    filterStateItemsRemoveClass(element, name) {
        let i
        let arr1
        let arr2

        arr1 = element.className.split(" ");
        arr2 = name.split(" ");
        for (i = 0; i < arr2.length; i++) {
            while (arr1.indexOf(arr2[i]) > -1) {
                arr1.splice(arr1.indexOf(arr2[i]), 1);
            }
        }
        element.className = arr1.join(" ")
    }
    
    
}